// extracted by mini-css-extract-plugin
module.exports = {"layout":"BaseLayout_layout__1cjPA","logo":"BaseLayout_logo__3q1N9"};